import * as React from "react";
import { Button, Text, makeStyles, tokens } from "@fluentui/react-components";
import { ChatMultiple24Regular, Add24Regular } from "@fluentui/react-icons";
import { useTypographyStyles } from "../../../styles/typography.styles";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingVerticalXXXL,
    textAlign: "center",
    gap: tokens.spacingVerticalL,
  },
  icon: {
    fontSize: "48px",
    color: tokens.colorNeutralForeground3,
  },
  message: {
    color: tokens.colorNeutralForeground2,
    maxWidth: "300px",
  },
});

interface EmptyStateProps {
  hasFilters: boolean;
  onCreateClick?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ hasFilters, onCreateClick }) => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  return (
    <div className={styles.container}>
      <ChatMultiple24Regular className={styles.icon} />

      <Text className={typography.emptyStateTitle}>
        {hasFilters ? "No discussions found" : "No discussions yet"}
      </Text>

      <Text className={styles.message}>
        {hasFilters
          ? "Try adjusting your filters or search terms"
          : "Get started by creating your first discussion"}
      </Text>

      {!hasFilters && onCreateClick && (
        <Button
          appearance="primary"
          icon={<Add24Regular />}
          onClick={onCreateClick}
        >
          Create Discussion
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
